/* @flow */
/* eslint-disable camelcase */
import Icons from "nexia_mobile/icons";
import type { BatteryFeature } from "./types";

export default function Battery(feature: BatteryFeature) {
  return {
    battery_label: (feature.label || "").trim().replace(/remaining$/, ""),
    battery_updated_at: feature.updated_at,
    battery_icon: Icons.getString(feature.icon),
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/battery.js